import { render, staticRenderFns } from "./PaymentRecap.vue?vue&type=template&id=466f3e74"
import script from "./PaymentRecap.vue?vue&type=script&lang=ts"
export * from "./PaymentRecap.vue?vue&type=script&lang=ts"
import style0 from "./PaymentRecap.vue?vue&type=style&index=0&id=466f3e74&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports